import React, { useEffect } from 'react';
import { CheckCircle, X } from 'lucide-react';

const Toast = ({ message, show, onClose, duration = 3000 }) => {
  useEffect(() => {
    if (show && duration) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [show, duration, onClose]);

  if (!show) return null;

  return (
    <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[99999] animate-slideDown">
      <div className="bg-gray-800 text-white px-6 py-3 rounded-xl shadow-2xl flex items-center gap-3 min-w-[200px]">
        <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0" />
        <span className="font-medium text-sm">{message}</span>
        <button
          onClick={onClose}
          className="ml-2 p-1 hover:bg-gray-700 rounded-lg transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default Toast;
